module.exports = __webpack_public_path__ + "img/tu8.f7f7bb83.png";